import * as React from 'react';
import Form from 'src/components/controls/forms/Form';
import IOwner from 'src/models/IOwner';
import AddressUtil from 'src/util/Address';
import { FieldArray } from 'react-final-form-arrays';
import FormRow from 'src/components/controls/forms/FormRow';
import * as _ from 'lodash';
import { FormApi } from 'final-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { ManageDeviationsPage } from './ManageDeviationsDialog';
import { AnyObject } from 'react-final-form';
import OwnerUtil from 'src/util/OwnerUtil';
import MergeContainer from 'src/models/MergeContainer';
export interface ITransferConfirmationContainerDialogProps {
    onTransferConfirmationCreatedForm: (form: FormApi) => void;
    changePage: (page: ManageDeviationsPage) => void;
    mergeContainer: (primaryOwnerId: number, mergeContainer: MergeContainer) => void;
}

export type ITransferConfirmationContainerStateProps = {
    originalOwnerDeviations: Array<IOwner>;
    targetOwnerDeviations: Array<IOwner>;
    form: FormApi;
    page: ManageDeviationsPage;
};

type ITransferConfirmationContainerDialogPageProps = ITransferConfirmationContainerDialogProps & ITransferConfirmationContainerStateProps;

class TransferConfirmationContainer extends React.Component<ITransferConfirmationContainerDialogPageProps> {
    constructor(props: ITransferConfirmationContainerDialogPageProps) {
        super(props);
    }

    ownerName = (owner: IOwner) => {
        let name = undefined;
        if (owner) {
            const mappedOwner = OwnerUtil.MapOwner(owner);
            name = mappedOwner ? mappedOwner.ownerName() : 'N/A';
        }
        return name;
    };

    confirmOwnerOriginalDeviations = (newDeviations: Array<IOwner>) => {
        return (
            <>
                {newDeviations.map((deviation: IOwner, index: number) => {
                    return (
                        <div key={name}>
                            <div style={{ maxWidth: '50rem', background: `${(deviation as AnyObject)?.isTarget ? '#b8ffb8' : 'transparent'}` }}>
                                <div>
                                    <label>
                                        <span className="owner-detail-info-name">{this.ownerName(deviation)}</span>
                                    </label>
                                </div>
                                <div className="owner-detail-info-address">
                                    {/* tslint:disable-next-line:max-line-length */}
                                    {AddressUtil.concatWithCommas(
                                        deviation?.address?.addressLine1,
                                        deviation?.address?.city,
                                        deviation?.address?.state?.name,
                                        deviation?.address?.zipCode
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </>
        );
    };

    confirmOwnerTargetDeviations = () => {
        if (this.props.targetOwnerDeviations === undefined) {
            return <></>;
        } else {
            return (
                <>
                    <FieldArray name="targetDeviations">
                        {({ fields, meta }) =>
                            fields.map((name, index) => (
                                <div key={name}>
                                    <div style={{ maxWidth: '50rem', textDecoration: 'line-through', background: '#ffb8b8' }}>
                                        <div>
                                            <label>
                                                <span className="owner-detail-info-name">
                                                    {this.ownerName(this.props.targetOwnerDeviations[index])}
                                                </span>
                                            </label>
                                        </div>
                                        <div className="owner-detail-info-address">
                                            {/* tslint:disable-next-line:max-line-length */}
                                            {AddressUtil.concatWithCommas(
                                                this.props.targetOwnerDeviations[index]?.address?.addressLine1,
                                                this.props.targetOwnerDeviations[index]?.address?.city,
                                                this.props.targetOwnerDeviations[index]?.address?.state?.name,
                                                this.props.targetOwnerDeviations[index]?.address?.zipCode
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </FieldArray>
                </>
            );
        }
    };

    prevPage = () => {
        this.props.changePage(ManageDeviationsPage.TransferPage);
    };

    submitMergeContainer = () => {
        const firstOriginal = this.props.originalOwnerDeviations ? this.props.originalOwnerDeviations[0] : undefined;
        const containerToKeep = firstOriginal ? firstOriginal.containerOwnerId : undefined;
        const containerToMerge = this.props.targetOwnerDeviations ? this.props.targetOwnerDeviations[0].containerOwnerId : undefined;
        if (containerToKeep && containerToMerge) {
            const mergeContainer = new MergeContainer();
            mergeContainer.containerToKeep = containerToKeep;
            mergeContainer.containerToMerge = containerToMerge;
            mergeContainer.ownerType = firstOriginal.ownerType;
            this.props.mergeContainer(firstOriginal.id, mergeContainer);
            this.props.changePage(ManageDeviationsPage.Menu);
        }
    };

    public render() {
        // mark green for new values
        this.props.targetOwnerDeviations?.forEach((x: AnyObject) => (x.isTarget = true));
        // may need to get values with shouldComponentUpdate for originalOwnerDeviations
        const newDeviations = this.props.originalOwnerDeviations?.concat(this.props.targetOwnerDeviations);

        return (
            <Form
                initialValues={{
                    newDeviations: newDeviations ? newDeviations : [],
                    targetDeviations: this.props.targetOwnerDeviations ? this.props.targetOwnerDeviations : [],
                }}
                hasFieldArray={true}
                showDebugValues={true}
                onSubmit={this.submitMergeContainer}
                onFormCreated={(form) => this.props.onTransferConfirmationCreatedForm(form)}
            >
                <div>
                    {this.props.page === ManageDeviationsPage.TransferConfirmation && (
                        <div style={{ width: '120rem', height: '50rem' }}>
                            <div style={{ fontWeight: 'bold', marginBottom: '3rem', fontSize: 'large' }}>Merge Preview</div>
                            <FormRow>
                                <div>
                                    <FormRow>
                                        <div className="lh-half-width">
                                            <div style={{ fontWeight: 'bold', marginBottom: '3rem' }}>Original Deviations</div>
                                            <div style={{ overflowY: 'auto', height: '30rem' }}>
                                                {this.confirmOwnerOriginalDeviations(newDeviations)}
                                            </div>
                                        </div>
                                        <div className="lh-half-width">
                                            <div style={{ fontWeight: 'bold', marginBottom: '3rem' }}>Deviations to Merge</div>
                                            <div style={{ overflowY: 'auto', height: '30rem' }}>{this.confirmOwnerTargetDeviations()}</div>
                                        </div>
                                    </FormRow>
                                </div>
                            </FormRow>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '6rem' }}>
                                <Button text="Prev" onClick={() => this.prevPage()} />
                                <Button className="ml-1" text="Merge Deviations" intent="primary" type="submit" />
                            </div>
                        </div>
                    )}
                </div>
            </Form>
        );
    }
}

export default TransferConfirmationContainer;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/TransferConfirmationContainer.tsx